// extracted by mini-css-extract-plugin
export var externalLink = "_c2-0";
export var internalLinkLabel = "_c2-1";